import React from "react";
import { Button, Spinner } from "react-bootstrap";
import downloadIcon from "../../assets/images/download_rgb_red.svg";
import { useFileExport } from "../../hooks/useFileExport";

const NewScopeButtons = () => {
  const { exportFile, isExporting, exportProgress } =
    useFileExport("/NewScope/Csv", "newScopes.csv");

  const handleDownload = async () => {
    try {
      await exportFile({});
    } catch {
      alert("Błąd eksportu danych.");
    }
  };

  return (
    <Button
      className="addresses-button"
      onClick={handleDownload}
      disabled={isExporting}
    >
      {isExporting ? (
        <div className="d-flex flex-column align-items-center">
          <Spinner animation="border" size="sm" />
          {exportProgress > 0 && (
            <small>{exportProgress}%</small>
          )}
        </div>
      ) : (
        <img
          src={downloadIcon}
          alt="Download"
          style={{ width: "75%", height: "75%" }}
        />
      )}
    </Button>
  );
};

export default NewScopeButtons;